import {ClientDesktopOnly} from 'components/ClientDesktopOnly';
import {NextButton} from 'modules/events/components/CalendarSlider/NextButton';
import {PrevButton} from 'modules/events/components/CalendarSlider/PrevButton';
import {CalendarSliderItem} from 'modules/events/components/CalendarSliderItem';
import {IEventsCalendarItem} from 'modules/events/helpers/calendar';
import {FC, useCallback, useMemo, useState} from 'react';
import {Swiper, SwiperClass, SwiperSlide} from 'swiper/react';
import {FreeMode} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/free-mode';
import style from './style.module.scss';

interface IProps {
    activeDay?: string;
    calendar: IEventsCalendarItem[];
    onSelectDay: (data: IEventsCalendarItem) => void;
}

export const CalendarSlider: FC<IProps> = ({activeDay, calendar, onSelectDay}) => {
    const [swiper, setSwiper] = useState<SwiperClass>();

    const handleSelectDay = useCallback(
        (data: IEventsCalendarItem) => {
            onSelectDay(data);
        },
        [onSelectDay],
    );

    const initialSlide = useMemo(() => {
        const index = calendar.findIndex(({dateString}) => dateString === activeDay);

        return -1 === index ? 0 : index;
    }, [activeDay, calendar]);

    return (
        <div className={style.main}>
            <Swiper
                className={style.swiper}
                freeMode={true}
                initialSlide={initialSlide}
                modules={[FreeMode]}
                onSwiper={setSwiper}
                slidesPerView={'auto'}
            >
                {calendar.map((data) => {
                    const {dateString, eventsCount} = data;

                    return (
                        <SwiperSlide className={style.slide} key={dateString}>
                            <CalendarSliderItem
                                data={data}
                                disabled={0 === eventsCount}
                                isActive={activeDay === dateString}
                                onSelectDay={handleSelectDay}
                            />
                        </SwiperSlide>
                    );
                })}
            </Swiper>
            <ClientDesktopOnly>
                <PrevButton swiper={swiper} />
                <NextButton swiper={swiper} />
            </ClientDesktopOnly>
        </div>
    );
};
